export default __webpack_public_path__ + "static/favicon-cd61099a66f3cb2f8a0dd3037e70fdf8.ico";